var angular = require('angular');
var _module = angular.module('benoit');

require('../../services/lr-touch');

_module.component('tapTest', {
    controllerAs: 'vm',
    controller: [
        function () {
            var vm = this;
            vm.model = {
                ngClicked: 0,
                lrTapped: 0
            };
        }
    ],
    template: require('./index.html')
});
